import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  createVehicule,
  getVehicules,
  updateVehicule,
} from "../services/vehiculeApi";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { Spin } from "antd";
import { getDrivers } from "../../Drivers/services/driverApi";
import { useTranslation } from "react-i18next";
import { Row, Col } from "reactstrap";
import "filepond/dist/filepond.min.css";
import { deleteMedia, uploadImage } from "../../Media/services/mediaApi";
import "filepond/dist/filepond.min.css";
import { Steps } from "antd";
import FileField from "../../../Components/Common/Form/FileField";
const { Step } = Steps;

const AddEditVehicleForm = ({ modal, setModal, toggle, selectedVehicule }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [image, setImage] = useState(null);

  const category = "user";

  const handlePhotoFileUpdate = (fileItems) => {
    setImage(fileItems.length > 0 ? fileItems[0].file : null);
  };

  const {
    isLoading: isLoadingDrivers,
    isError: isErrorDrivers,
    error: errorDrivers,
    data: drivers,
  } = useQuery("drivers", getDrivers);

  const {
    isLoadingStatus,
    isErrorStatus,
    error,
    data: vehicules = [],
  } = useQuery("vehicules", getVehicules);

  const validationSchema = Yup.object().shape({
    brand: Yup.string().required("Veuillez renseigner la marque de la voiture"),
    model: Yup.string().required("Veuillez renseigner le modèle de la voiture"),
    description: Yup.string().optional(),
    transmission: Yup.string().optional(),
    speed: Yup.number().min(0, "La vitesse doit être positive").optional(),
    registrationNumber: Yup.string().required("Oups!!! Veuillez renseigner le numéro de la plaque"),
    commissioningDate: Yup.date().required("Veuillez renseigner la date de mise en service"),
    vin: Yup.string().required("Veuillez renseigner le VIN"),
    mileage: Yup.number().min(0, "Le kilométrage doit être positif").optional(),
    color: Yup.string(t("vehicleForm.color")),
    statut: Yup.string().required(t("vehicleForm.statut")),
  });
  const initialValues = selectedVehicule
    ? {
        model: selectedVehicule.model,
        brand: selectedVehicule.brand,
        statut: selectedVehicule.statut,
        description: selectedVehicule.description,
        transmission: selectedVehicule.transmission,
        speed: selectedVehicule.speed,
        registrationNumber: selectedVehicule.registrationNumber,
        commissioningDate: selectedVehicule.commissioningDate,
        vin: selectedVehicule.vin,
        mileage: selectedVehicule.mileage,
        actualUserId: selectedVehicule.actualUserId,
        fileName: selectedVehicule.fileName || "",
        color: selectedVehicule.color,
      }
    : {
        registrationNumber: "",
        model: "",
        commissioningDate: "",
        actualUserId: "",
        mileage: "",
        statut: "",
        fileName: "",
        brand: "",
        description: "",
        transmission: "",
        speed: "",
        vin: "",
        color: "",
      };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => handleSubmit(values),
  });

  const isStepValid = () => {
    if (currentStep === 0) {
      return (
        formik.values.model &&
        formik.values.brand &&
        formik.values.actualUserId &&
        formik.values.statut
      );
    }
    if (currentStep === 1) {
      return (
        formik.values.registrationNumber &&
        formik.values.vin &&
        formik.values.transmission &&
        formik.values.color &&
        formik.values.commissioningDate &&
        formik.values.mileage &&
        formik.values.speed
      );
    }
    return false;
  };

  const handleSubmit = async (values) => {
    setIsLoadingSubmit(true);
    let fileName = values.fileName;

    try {
      if (image) {
        const response = await uploadImage(category, image);
        fileName = response?.name;
      }

      const vehicleData = {
        ...values,
        fileName,
      };
      if (selectedVehicule) {
        await updateVehicule(selectedVehicule.id, vehicleData);
        toast.success("Voiture modifiée avec succès 🎉");
      } else {
        await createVehicule(vehicleData);
        toast.success("Voiture ajoutée avec succès ✅");
      }
      await queryClient.invalidateQueries("vehicules");
      toggle();
      formik.resetForm();
    } catch (error) {
      toast.error("Erreur : " + error?.message);
      if (image && fileName) {
        try {
          await deleteMedia(fileName);
        } catch (deleteError) {
          console.error(
            "Erreur lors de la suppression de l'image :",
            deleteError
          );
        }
      }
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  useEffect(() => {
    formik.setValues(initialValues);
  }, [selectedVehicule]);

  const transmissionData = [{ name: "Manuel" }, { name: "Automatique" }];

  const handlePrevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };
  const modalTitle = selectedVehicule ? t("vehicleForm.edit_v") : t("vehicleForm.add_v");
  const handleNextStep = (e) => {
    e.preventDefault();
    if (currentStep === 1) {
      formik.handleSubmit();
    } else {
      setCurrentStep(currentStep + 1);
    }
  };
  
  const uniqueStatus = Array.isArray(vehicules) ? [...new Set(vehicules.map((v) => v.statut))] : [];

  return (
    <div className="" style={{ borderRadius: "220px" }}>
      <Modal
        id="showModalClient"
        isOpen={modal}
        toggle={toggle}
        centered
        backdrop={"static"}
        style={{
          maxWidth: "900px"
        }}
      >
        <ModalHeader className="d-flex justify-content-center align-items-center p-3">
            <div>
              <h3 className="text-center">{modalTitle}</h3>
            </div>
            <div className="horizontal-line-container">
              <div
                className={`circle ${currentStep >= 0 ? "active" : ""} ${
                  currentStep > 0 ? "completed" : ""
                }`}
              >
                <div
                  className={`small-circle ${currentStep >= 1 ? "active" : ""}`}
                >
                  {currentStep > 0 && <span className="checkmark">✔</span>}
                </div>
                <span
                  className={`circle-text ${
                    currentStep > 0 ? "completed-text" : "in-progress-text"
                  }`}
                >
                  {currentStep > 0
                    ? "Spécifications (Terminée)"
                    : currentStep === 0
                    ? "Spécifications (En cours)"
                    : "Spécifications"}
                </span>
              </div>

              <div
                className={`horizontal-line ${
                  currentStep >= 1 ? "completed" : "in-progress"
                }`}
              ></div>
              <div
                className={`circle ${currentStep >= 1 ? "active" : ""} ${
                  currentStep > 1 ? "completed" : ""
                }`}
              >
                <div
                  className={`small-circle ${currentStep >= 1 ? "active" : ""}`}
                >
                  {currentStep > 1 && <span className="checkmark">✔</span>}
                </div>

                <span
                  className={`circle-text ${
                    currentStep > 1 ? "completed-text-C" : "in-progress-text-C"
                  }`}
                >
                  {currentStep === 0
                    ? "Détails (Suivant)"
                    : currentStep === 1
                    ? "Détails (Encours)"
                    : "Détails "}
                </span>
              </div>
            </div>
        </ModalHeader>
        
        <Row>
          <Col className="d-flex justify-content-end gap-2 mt-3 mt-n5">
            <Button
              color="light"
              className="bordered-btn-lightR btn-spacing"
              onClick={() => setModal(false)}
            >
              {t("vehicleForm.cancel")}
            </Button>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col lg={6}>
            {currentStep === 1 && (
              <a
                style={{
                  color: "#1F5357",
                  fontWeight: "500px",
                  fontSize: "16px",
                  fontFamily: "Inter",
                  display: "inline-block",
                  marginTop: "50px",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={handlePrevStep}
                disabled={isLoadingSubmit}
              >
                Précédent
              </a>
            )}
          </Col>
        </Row>

        <Form onSubmit={formik.handleSubmit}>
          <ModalBody>
            {currentStep === 0 && (
              <>
                <Row className="justify-content-center mt-5">
                  <FileField
                        label="Photo du véhicule"
                        name="fileName"
                        formik={formik}
                        file={image}
                        onUpdateFiles={handlePhotoFileUpdate}
                        helperText="La photo du véhicule est optionnelle mais elle est recommandée"
                        colSize={6}
                      />
                </Row>
                <Row className="justify-content-center">
                  <Col lg={6}>
                    <div className="mb-3">
                      <label
                        htmlFor="model"
                        className="form-label"
                        style={{
                          color: "#6C6B6B",
                          fontFamily: "Inter",
                          fontWeight: "400px",
                          size: "14px",
                        }}
                      >
                        {t("vehicleForm.model")}
                      </label>
                      <input
                        type="text"
                        id="model"
                        name="model"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.model}
                      />
                      {formik.touched.model && formik.errors.model && (
                        <div className="text-danger">{formik.errors.model}</div>
                      )}
                    </div>
                  </Col>
                </Row>
                <Row className="justify-content-center">
                  <Col lg={6}>
                    <div className="mb-3">
                      <label
                        htmlFor="brand"
                        className="form-label"
                        style={{
                          color: "#6C6B6B",
                          fontFamily: "Inter",
                          fontWeight: "400px",
                          size: "14px",
                        }}
                      >
                        {t("vehicleForm.name")}
                      </label>
                      <input
                        type="text"
                        id="brand"
                        name="brand"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.brand}
                      />
                      {formik.touched.brand && formik.errors.brand && (
                        <div className="text-danger">{formik.errors.brand}</div>
                      )}
                    </div>
                  </Col>
                </Row>

                <Row className="justify-content-center">
                  <Col lg={6}>
                    <div className="mb-3">
                      <label
                        htmlFor="description"
                        className="form-label"
                        style={{
                          color: "#6C6B6B",
                          fontFamily: "Inter",
                          fontWeight: "400px",
                          size: "14px",
                        }}
                      >
                        {t("types.description")}
                      </label>
                      <textarea
                        id="description"
                        name="description"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.description}
                        rows="4"
                      />
                      {formik.touched.description &&
                        formik.errors.description && (
                          <div className="text-danger">
                            {formik.errors.description}
                          </div>
                        )}
                    </div>
                  </Col>
                </Row>
                <Row className="justify-content-center">
                  <Col lg={6}>
                    <div className="mb-3">
                      <label
                        htmlFor="actualUserId"
                        className="form-label"
                        style={{
                          color: "#6C6B6B",
                          fontFamily: "Inter",
                          fontWeight: "400px",
                          size: "14px",
                        }}
                      >
                        {t("vehicleForm.actualDriver")}
                      </label>
                      <select
                        id="actualUserId"
                        name="actualUserId"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.actualUserId}
                      >
                        <option value="">
                          {t("vehicleForm.selectDriver")}
                        </option>
                        {isLoadingDrivers ? (
                          <option>{t("vehicleForm.selectDriver")}</option>
                        ) : isErrorDrivers ? (
                          <option>
                            {t("vehicleForm.error")}{" "}
                            {errorDrivers?.message || errorDrivers}
                          </option>
                        ) : (
                          drivers &&
                          drivers.map((driver) => (
                            <option key={driver.id} value={driver.id}>
                              {driver?.name}
                            </option>
                          ))
                        )}
                      </select>
                      {formik.touched.actualUserId &&
                      formik.errors.actualUserId ? (
                        <div className="text-danger">
                          {formik.errors.actualUserId}
                        </div>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row className="justify-content-center">
                  <Col lg={6}>
                    <div className="mb-3">
                      <label
                        htmlFor="statut"
                        className="form-label"
                        style={{
                          color: "#6C6B6B",
                          fontFamily: "Inter",
                          fontWeight: "400px",
                          fontSize: "14px",
                        }}
                      >
                        Statut <span className="text-danger">*</span>
                      </label>
                      <select
                        id="statut"
                        name="statut"
                        className="form-control"
                        onChange={formik.handleChange}
                        value={formik.values.statut}
                        // disabled={isLoading}
                      >
                        <option value="">-- Sélectionnez un statut --</option>
                        {uniqueStatus.length > 0 ? (
                          uniqueStatus.map((statut, index) => (
                            <option key={index} value={statut}>
                              {statut}
                            </option>
                          ))
                        ) : (
                          <option disabled>Chargement...</option>
                        )}
                      </select>

                      {formik.touched.type && formik.errors.statut && (
                        <div className="text-danger">
                          {formik.errors.statut}
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </>
            )}

            {currentStep === 1 && (
              <>
                <Row className="justify-content-center">
                  <Col
                    lg={6}
                    style={{
                      color: "#252525",
                      fontSize: "18px",
                      fontWeight: "bold",
                      fontFamily: "Raleway",
                    }}
                  >
                    Caracteristiques techniques
                  </Col>
                </Row>
                
                <Row className="justify-content-center">
                  <Col lg={6}>
                    <div className="mb-3">
                      <label
                        htmlFor="registrationNumber"
                        className="form-label"
                        style={{
                          color: "#6C6B6B",
                          fontFamily: "Inter",
                          fontWeight: "400px",
                          size: "14px",
                        }}
                      >
                        {t("vehicleForm.registrationNumber")}
                      </label>
                      <input
                        type="text"
                        id="registrationNumber"
                        name="registrationNumber"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.registrationNumber}
                        required
                        placeholder="Entre la plaque d'immatricualtion"
                      />
                      {formik.touched.registrationNumber &&
                        formik.errors.registrationNumber && (
                          <div className="text-danger">
                            {formik.errors.registrationNumber}
                          </div>
                        )}
                    </div>
                  </Col>
                </Row>
                
                <Row className="justify-content-center">
                  <Col lg={6}>
                    <div className="mb-3">
                      <label
                        htmlFor="vin"
                        className="form-label"
                        style={{
                          color: "#6C6B6B",
                          fontFamily: "Inter",
                          fontWeight: "400px",
                          size: "14px",
                        }}
                      >
                        {t("vehicleForm.vin")}
                      </label>
                      <input
                        type="text"
                        id="vin"
                        name="vin"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.vin}
                         placeholder="Entrer le VIN"
                      />
                      {formik.touched.vin && formik.errors.vin && (
                        <div className="text-danger">{formik.errors.vin}</div>
                      )}
                    </div>
                  </Col>
                </Row>

                <Row className="justify-content-center">
                  <Col lg={6}>
                    <div className="mb-3">
                      <label
                        htmlFor="transmission"
                        className="form-label"
                        style={{
                          color: "#6C6B6B",
                          fontFamily: "Inter",
                          fontWeight: "400px",
                          fontSize: "14px",
                        }}
                      >
                        {t("vehicleForm.transmission")}
                      </label>

                      <select
                        id="transmission"
                        name="transmission"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.transmission || ""}
                      >
                        <option value="">
                          -- Sélectionnez une transmission --
                        </option>
                        {transmissionData.map((option, index) => (
                          <option key={index} value={option.name}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                      {formik.touched.transmission &&
                        formik.errors.transmission && (
                          <div className="text-danger">
                            {formik.errors.transmission}
                          </div>
                        )}
                    </div>
                  </Col>
                </Row>

                <Row className="justify-content-center">
                  <Col lg={6}>
                    <div className="mb-3">
                      <label
                        htmlFor="transmission"
                        className="form-label"
                        style={{
                          color: "#6C6B6B",
                          fontFamily: "Inter",
                          fontWeight: "400px",
                          size: "14px",
                        }}
                      >
                        Couleur véhicule
                      </label>
                      <input
                        type="text"
                        id="color"
                        name="color"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.color}
                      />
                      {formik.touched.color && formik.errors.color && (
                        <div className="text-danger">{formik.errors.color}</div>
                      )}
                    </div>
                  </Col>
                </Row>
                <Row className="justify-content-center">
                  <Col lg={6}>
                    <div className="mb-3">
                      <label
                        htmlFor="commissioningDate"
                        className="form-label"
                        style={{
                          color: "#6C6B6B",
                          fontFamily: "Inter",
                          fontWeight: "400px",
                          size: "14px",
                        }}
                      >
                        {t("vehicleForm.commissioningDate")}
                      </label>
                      <input
                        type="date"
                        id="commissioningDate"
                        name="commissioningDate"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.commissioningDate}
                      />
                      {formik.touched.commissioningDate &&
                      formik.errors.commissioningDate ? (
                        <div className="text-danger">
                          {formik.errors.commissioningDate}
                        </div>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row className="justify-content-center">
                  <Col lg={6}>
                    <div className="mb-3">
                      <label
                        htmlFor="mileage"
                        className="form-label"
                        style={{
                          color: "#6C6B6B",
                          fontFamily: "Inter",
                          fontWeight: "400px",
                          fontSize: "14px",
                        }}
                      >
                        {t("vehicleForm.currentMileage")}
                      </label>
                      <input
                        type="number"
                        id="mileage"
                        name="mileage"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.mileage}
                        onKeyDown={(e) => {
                          // Empêcher les lettres et autres caractères non numériques
                          const charCode = e.keyCode || e.which;

                          // Si ce n'est pas une touche numérique, une touche de contrôle, ou un point (si vous souhaitez autoriser les décimales)
                          if (
                            !(charCode >= 48 && charCode <= 57) &&
                            charCode !== 8 &&
                            charCode !== 46
                          ) {
                            e.preventDefault(); // Empêche la saisie de la touche
                          }
                        }}
                      />
                      {formik.touched.mileage && formik.errors.mileage ? (
                        <div className="text-danger">
                          {formik.errors.mileage}
                        </div>
                      ) : null}
                    </div>
                  </Col>
                </Row>

                <Row className="justify-content-center">
                  <Col lg={6}>
                    <div className="mb-3">
                      <label
                        htmlFor="speed"
                        className="form-label"
                        style={{
                          color: "#6C6B6B",
                          fontFamily: "Inter",
                          fontWeight: "400px",
                          fontSize: "14px",
                        }}
                      >
                        {t("vehicleForm.speed")}
                      </label>
                      <input
                        type="number"
                        id="speed"
                        name="speed"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.speed}
                        onKeyDown={(e) => {
                          const charCode = e.keyCode || e.which;
                          if (
                            !(charCode >= 48 && charCode <= 57) &&
                            charCode !== 8 &&
                            charCode !== 46
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                      {formik.touched.speed && formik.errors.speed ? (
                        <div className="text-danger">{formik.errors.speed}</div>
                      ) : null}
                    </div>
                  </Col>
                </Row>
              </>
            )}
          </ModalBody>

          <Row className="justify-content-center">
            <Col lg={6}>
              <Button
                type="button"
                className="bordered-btn"
                style={{
                  borderRadius: "20px",
                  marginRight: "100px",
                  border: "2px #1F5357",
                  width: "100%",
                }}
                onClick={(e) => handleNextStep(e)}
                disabled={isLoadingSubmit || !isStepValid()}
              >
                {isLoadingSubmit ? (
                  <Spin size="small" />
                ) : currentStep === 1 ? (
                  selectedVehicule ? (
                    "Modifier"
                  ) : (
                    "Terminer"
                  )
                ) : (
                  "Suivant"
                )}
              </Button>
            </Col>
          </Row>

          <ModalFooter>
            <div className="d-flex justify-content-end gap-2 mt-3"></div>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};
export default AddEditVehicleForm;
